import "./styles.css";
import { List, Typography, message, Space, Button, Modal, Form, Row, Col, Upload } from "antd";
import { DeleteOutlined, EditOutlined, FileOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { configModal } from "../../../../../components/modalConfig/config";
import http from "../../../../../services/http";
import { createUUID } from "../../../../../helpers/generateUid";
import { RenderDocument } from "./components/renderDocument";
const { Text } = Typography;

const Anexos = ({ id, dataLoading, editable }) => {
  const [anexos, setAnexos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [form] = Form.useForm();
  const files = Form.useWatch("files", form);

  useEffect(() => {
    if (id > 0) {
      listarAnexos(id);
    }
  }, [id]);

  const listarAnexos = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_anexos/listar/${id}`, []);
    if (api.statusCode === 200) {
      setAnexos(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const deletarAnexo = async (id_delete) => {
    if (!id_delete) return;
    setLoading(true);
    const api = await http("post", `v1/problemas_anexos/deletar`, { id: id_delete });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarAnexos(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const adicionarAnexos = async (formData) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/problemas_anexos/adicionar`, formData);
    if (api.statusCode === 200) {
      message.success("Registro adicionado com sucesso!");
      setShowModal(false);
      form.resetFields();
      listarAnexos(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    const formData = new FormData();
    formData.append("id_problemas", id ?? 0);

    for (let f of formulario?.files ?? []) {
      formData.append("files[]", f?.originFileObj ?? "");
    }

    adicionarAnexos(formData);
  };

  const formFile = (e) => {
    const size = e?.file?.size / 1024 / 1024 > 25;
    if (size) {
      message.error("Tamanho não suportado, máximo 25MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const handlePaste = (e) => {
    setLoading(true);
    if (e?.clipboardData?.files?.length) {
      if (files?.length >= 5) {
        setLoading(false);
        return;
      }

      const file = e?.clipboardData?.files[0];

      const arquivo = {
        uid: createUUID(),
        originFileObj: file,
        name: file?.name,
        lastModified: file?.lastModified,
        lastModifiedDate: file?.lastModifiedDate,
        type: file?.type,
        size: file?.size,
      };

      form?.setFieldsValue({ files: [...(files ?? []), arquivo] });
    } else {
      message.error("Nenhum arquivo selecionado!");
    }
    setLoading(false);
  };

  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> Novo Anexo
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={700}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        form.resetFields();
      }}>
      <Form onPaste={handlePaste} form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              getValueFromEvent={formFile}
              name="files"
              valuePropName="fileList"
              label={
                <Text>
                  Anexos (Opcional) <Text type="secondary">Máx: 5</Text>
                </Text>
              }
              rules={[{ required: true, message: "Adicione um anexo!" }]}>
              <Upload
                iconRender={() => <FileOutlined />}
                listType="picture"
                disabled={loading}
                multiple
                beforeUpload={() => false}
                maxCount={5}>
                <Button loading={loading} size="large" icon={<UploadOutlined />}>
                  Click para enviar
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <>
      <List
        header={
          <Space className="card-header-content full-width">
            <Text strong style={{ fontSize: 18, color: "#60b565" }}>
              Anexos
            </Text>

            {editable && (
              <Button
                type="primary"
                loading={loading}
                icon={<PlusOutlined />}
                onClick={() => {
                  setShowModal(true);
                  form?.resetFields();
                }}
              />
            )}
          </Space>
        }
        loading={loading ?? dataLoading}
        dataSource={anexos}
        renderItem={(item) => (
          <List.Item>
            <Space className="card-header-content full-width" wrap>
              <Space direction="vertical" size={0}>
                <Text strong>{item?.nome}</Text>
              </Space>

              <Space>
                <RenderDocument id={item?.id} name={item?.nome} type={item?.formato} />
                {editable && (
                  <Button
                    danger
                    type="text"
                    loading={loading}
                    icon={<DeleteOutlined />}
                    onClick={() =>
                      modal.confirm({
                        ...configModal,
                        title: "Atenção",
                        content: "Deseja deletar este registro?",
                        onOk() {
                          deletarAnexo(item?.id);
                        },
                      })
                    }
                  />
                )}
              </Space>
            </Space>
          </List.Item>
        )}
      />
      {modalFormulario}
      {contextHolder}
    </>
  );
};

export { Anexos };
